import { jsx as _jsx } from "react/jsx-runtime";
import { StyledManageCookiesContainer, StyledManageCookiesLink } from './ManageCookies.styles';
import enviro from 'enviro';
export const ManageCookies = () => {
  const isCookieBannerOnPage = document.body.getElementsByClassName('cookie-banner-top-static').length > 0;
  const isQA = enviro.isQa();

  if (!isCookieBannerOnPage && isQA) {
    console.warn('Cookie banner script is not loaded on this page, the ManageCookies component will not render');
  }

  return /*#__PURE__*/_jsx(StyledManageCookiesContainer, {
    children: /*#__PURE__*/_jsx("div", {
      className: "hs-footer-cookie-settings",
      children: /*#__PURE__*/_jsx(StyledManageCookiesLink, {
        href: "#"
      })
    })
  });
};